import React from 'react';

import { Col, Row } from 'reactstrap';
import styled, { css } from 'styled-components';
import { switchProp } from 'styled-tools';

import ContentContainer from 'components/ContentContainer/ContentContainer';
import CtaButton from 'components/CtaButton/CtaButton';
import RowBorderTable from 'components/ModularBlocks/BasicTableBlock/RowBorderTable';
import StackHeader from 'components/StackHeader';

import { BasicTableBlockI } from 'interfaces/content-stack/modular-blocks/basicTableBlock';

import { getModularBlockLinkData } from 'utils/modularBlockUtils';

export interface BasicTableBlockProps {
  className?: string;
  data: BasicTableBlockI;
}

const CtaButtonContainer = styled.div<{ $alignment: string }>`
  display: flex;

  ${switchProp('$alignment', {
    left: css`
      padding-left: 1.5rem;
      @media (max-width: ${(props) => props.theme.breakpoints.md}) {
        padding-left: 1rem;
      }
    `,
  })}
`;

const BasicTableBlock: React.FC<BasicTableBlockProps> = ({ data, className }) => {
  if (!data) {
    return null;
  }

  const { header, headerColor, headerType, tables } = data;

  return (
    <ContentContainer className={className}>
      <Row>
        {header && (
          <Col xs={12}>
            <StackHeader headerPrimaryColor={headerColor} headerType={headerType}>
              {header}
            </StackHeader>
          </Col>
        )}
        {tables?.map((table, index) => {
          const {
            lineHeight,
            tableTitle,
            tableColumns,
            tableHeaders,
            tableWidth,
            columnContentAlignment,
            cssClassname,
          } = table;

          return (
            <Col key={index} sm={12} md={tableWidth}>
              <RowBorderTable
                tableColumns={tableColumns}
                columnContentAlignment={columnContentAlignment}
                tableHeaders={tableHeaders}
                lineHeight={lineHeight}
                tableTitle={tableTitle}
                cssClassname={cssClassname}
              />
              {table.ctaButtons?.map((button, buttonIndex) => {
                const { link, openInNewWindow } = getModularBlockLinkData(button.buttonLink);
                return (
                  <CtaButtonContainer $alignment={columnContentAlignment} key={buttonIndex}>
                    <CtaButton
                      to={link}
                      openInNewWindow={openInNewWindow}
                      buttonType={button.buttonType}
                      text={button.buttonText}
                      bold
                    />
                  </CtaButtonContainer>
                );
              })}
            </Col>
          );
        })}
      </Row>
    </ContentContainer>
  );
};

export default React.memo(BasicTableBlock);
